// extracted by mini-css-extract-plugin
export default {"wrapper":"Users_wrapper__QxkoM","spinner":"Users_spinner__PcS5q","noDataCap":"Users_noDataCap__cQ3Yu"};